export default __webpack_public_path__ + "static/mwbmakler-cea8080c097dedffd497d5fb98a9ffb4.jpg";